const calendarLang = {
  pageTitle: 'Agenda',
  addTitle: 'Création d\'un agenda',
  editTitle: 'Modification d\'un agenda',
  newBtn: 'Créer un agenda',
  deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet agenda ?',
  deleteSharedMsg: 'Cet agenda est partagé. Êtes-vous sûr de vouloir arrêter le partage de cet agenda ?',
  editSharedMsg: 'Cet agenda est partagé, les modifications seront visibles que par vous.',
  needCreateCalendar: 'Vous devez créer agenda pour continuer.',
  headerMoreEvent: '{count} évènemen de plus|{count} évènements de plus',
  headerNoEvent: 'Aucun évènement',
  headerSeeAllEvent: 'Voir tous les évènements',
  noResults: 'Aucun résultat',
  appointment: 'Rendez-vous',
  searchTypesPlaceholder: 'Rechercher un élément auquel rattacher cet événement',
  readonlyCalendar: 'Agenda en lecture seule',
  searchTypes: {
    customer: 'Tiers',
    contact: 'Contact',
    affair: 'Affaire',
    quotation: 'Devis',
    command: 'Bon de commande',
    delivery: 'Bon de livraison',
    proforma: 'Facture proforma',
    invoice: 'Facture',
    credit: 'Avoir',
    providerCommand: 'Commande'
  },
  calendar: {
    name: 'Nom de l\'agenda',
    foregroundColor: 'Couleur de fond',
    color: 'Couleur du texte',
    share: 'Partage de l\'agenda',
    searchUser: 'Rechercher un utilisateur',
    noUser: 'Aucun utilisateur',
    readonly: 'Lecture seule'
  },
  event: {
    timeRange: 'De {begin} à {end}',
    addTitle: 'Création d\'un événement',
    editTitle: 'Modification d\'un événement',
    newBtn: 'Créer un événement',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet événement ?',
    noTitle: 'Événement sans titre',
    title: 'Titre de l\'événement',
    begin: 'Début',
    allDay: 'Toute la journée',
    end: 'Fin',
    calendar: 'Agenda',
    informations: 'Informations complémentaires',
    location: 'Lieu',
    comments: 'Description',
    customColor: 'Couleur personnalisée',
    color: 'Couleur du texte :',
    foregroundColor: 'Couleur de fond :',
    recurrence: 'Récurrence',
    repeatEvent: 'Répéter cet événement',
    repeatEvery: 'Répéter tou(te)s les',
    repeatThe: 'Répéter le',
    endThe: 'Se termine le',
    never: 'Jamais',
    the: 'Le',
    after: 'After',
    occurence: 'Occurence(s)|Occurence|Occurences',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'années'
  },
  params: {
    notifications: {
      0: 'Jamais',
      1: 'Tous les jours',
      2: 'Tous les lundi'
    },
    modalTitle: 'Configuration des agendas',
    defaultCalendar: 'Calendrier par défaut lors la création d\'un nouvel événement',
    displayParams: 'Paramètres d\'affichage',
    displayFirstHour: 'Première heure à afficher',
    minHour: 'Heure minimum',
    maxHour: 'Heure maximum',
    defaultView: 'Vue par défaut',
    taskInCalendar: 'Afficher les tâches dans l\'agenda',
    textColor: 'Couleur du texte :',
    foregroundColor: 'Couleur de fond :',
    eventInInterface: 'Affichage des événements dans l\'interface',
    topInterface: 'Dans la partie haute de l\'interface, afficher les notifications sur :',
    mailNotifications: 'Notifications par email',
    getNotifications: 'Recevoir la liste des événements à venir par email :',
    notificationHour: 'Heure d\'envoi de l\'email :'
  },
  day: 'Jour',
  week: 'Semaine',
  month: 'Mois',
  list: 'Liste',
  today: 'Aujourd\'hui',
  configuration: 'Configuration',
  tasks: 'Tâches',
  days: {
    1: 'Lundi',
    2: 'Mardi',
    3: 'Mercredi',
    4: 'Jeudi',
    5: 'Vendredi',
    6: 'Samedi',
    7: 'Dimanche'
  },
  hours: {
    0: '00h00',
    1: '01h00',
    2: '02h00',
    3: '03h00',
    4: '04h00',
    5: '05h00',
    6: '06h00',
    7: '07h00',
    8: '08h00',
    9: '09h00',
    10: '10h00',
    11: '11h00',
    12: '12h00',
    13: '13h00',
    14: '14h00',
    15: '15h00',
    16: '16h00',
    17: '17h00',
    18: '18h00',
    19: '19h00',
    20: '20h00',
    21: '21h00',
    22: '22h00',
    23: '23h00'
  }
}

export default {
  calendars: calendarLang
}
